<div class="row" (click)="toggleAnswer($event)">
    <div class="questionText col-10 col-md-6">{{question.display_index}}. {{question.prompt}}</div>
    <div class="col-2 col-md-6">
      <input id="check-{{question.id}}" type="checkbox" class="form-control col-2" 
      [checked]="isChecked()" (click)="toggleAnswer($event)" />
      <label for="check-{{question.id}}"></label>
    </div>
  </div>


// WEBPACK FOOTER //
// ./src/app/assessments/question-single-checkbox/question-single-checkbox.component.html